import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from "@time-theft-analyzer/shared";
import { useAuth } from "@time-theft-analyzer/shared";
import { buildLoginPath } from '../utils/returnUrl';

interface PrivateRouteProps {
  children: React.ReactNode;
  requiredApp?: string;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, requiredApp }) => {
  const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);
  const token = localStorage.getItem('token');
  const { loading, hasAppAccess } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  if (!isAuthenticated && !token) {
    // Preserve the page the user was trying to reach so login can send them back.
    return <Navigate to={buildLoginPath(location)} replace />;
  }

  // Check app-level access if required
  if (requiredApp && !hasAppAccess(requiredApp)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-6">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Access Denied</h2>
            <p className="text-gray-600 mb-6">
              You don't have access to this application. Please contact your administrator.
            </p>
            <button
              onClick={() => window.location.href = '/'}
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
            >
              Return to App Selector
            </button>
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default PrivateRoute;